import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import * as $ from 'jquery';
import { interval } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { Meta, MetaDefinition } from '@angular/platform-browser';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { environment } from '../../environments/environment';


@Component({
  selector: 'app-conoce-centro-ayuda',
  templateUrl: './conoce-centro-ayuda.component.html',
  styleUrls: ['./conoce-centro-ayuda.component.scss']
})
export class ConoceCentroAyudaComponent implements OnInit {
  public isBrowser = isPlatformBrowser(this.platformId);
  public isServer = isPlatformServer(this.platformId);

  constructor(
    private titleService: Title,
    private metaService:Meta,
    @Inject(PLATFORM_ID) private platformId: any,
    private gtmService: GoogleTagManagerService,
  ) { }

  sub: any;

  ngOnInit(): void {
    this.titleService.setTitle('Conoce el Centro de Ayuda de Metrogas | Metrogas');
    this.metaService.updateTag({ name: 'description', content: 'Conoce el nuevo centro de ayuda en línea de Metrogas.' })

    if (this.isBrowser) {
      if (environment.production) {
        this.gtmService.addGtmToDom();
      }

      setTimeout(() => {
        $(".video-responsive")[0].scrollIntoView();
      }, 1000);
    }
  }
}
